import { Injectable, Type } from '@angular/core';
import { ModalService } from '@niceltd/sol/modal';
import { Observable } from 'rxjs';
import { ReportSubscription } from 'src/shared/models/subscriptions.model';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionModalService {

    private modalData: SubscriptionOptions = null;

    constructor(
        private readonly solModalService: ModalService,
    ) { }

    public openModal(options: SubscriptionOptions, modalComponent: Type<any>): Observable<any> {
        if (!options || typeof options !== "object")
            throw "Options argument is required";

        this.modalData = options;

        const modalRef = this.solModalService.open(modalComponent, {
            animation: true,
            backdrop: 'static',
            disableClose: true
        });

        return modalRef;
    }

    public _getModalData(): SubscriptionOptions {
        const modalData = this.modalData;
        this.modalData = null;
        return modalData;
    }
}

export interface SubscriptionOptions {
    embedMode: boolean;
    reportType: number;
    subscriptionId: number;
    existingSchedule?: ReportSubscription;
    subscriptionTitle: string;
    relatedId: number;
    dashboardKey: string;
}
